/* ==============================================
   Entry point.

   Two ways in, decided by whether the HTML that
   arrived already has the page in it:

     - Prerendered (the shipped build). scripts/
       prerender.mjs wrote real markup into
       #root at build time, so React hydrates it:
       the text is on screen and readable by a
       crawler before any JavaScript runs.

     - Empty (npm start, and any route the
       prerender step didn't cover). React renders
       from scratch, exactly as before.
   ============================================== */

import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import './index.css';
import App from './App';

const container = document.getElementById('root');

const tree = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (container.hasChildNodes()) {
  /* The prerendered <head> carries this route's title, description,
     canonical and card so a crawler gets them without running anything.
     Helmet is about to render its own copy of all of it, so drop the baked
     set first — otherwise the live page has two of each. Removing them here,
     rather than in the HTML, means a bundle that never loads still leaves a
     page with its metadata intact. */
  document
    .querySelectorAll("[data-prerendered-head]")
    .forEach((el) => el.remove());

  hydrateRoot(container, tree);
} else {
  createRoot(container).render(tree);
}
